<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <h3 class="margin-b-8">Afgerond</h3>
        <div class="fs-small" v-if="words || sworn">{{words + ' woorden'}}{{ words && sworn ? ', ': ''}}{{ sworn ? sworn + ' beëdigingen': ''}}</div>
        <i class="fs-small">Afgetekend op {{date | datetime}}</i>
    </div>
</template>

<script>
export default {
    props: {
        words: {
            default: null
        },
        sworn: {
            default: null
        },
        date: {
            type: String,
            required: true
        }
    }
}
</script>
